import React from 'react';
import './RegisterAfaziliRightSide.css';
import googleicon from '../../../assets/images/google-icon.png';

const RegisterAfaziliRightSide = () => {
    return (
        <section className="register-afazili-right-section">
            <h1>Kayıt OI</h1>
            <button className="google-button">
                <img src={googleicon} alt="google-icon" />
                Google ile Hesap Aç
            </button>
            <div className="divider">
                <span>Veya</span>
            </div>
            <form className="form">
                <div className="form-row">
                    <div className="form-group">
                        <label>İsim</label>
                        <input type="text" className='isim-soyisim' />
                    </div>
                    <div className="form-group">
                        <label>Soyisim</label>
                        <input type="text" className='isim-soyisim' />
                    </div>
                </div>

                <div className="form-group">
                    <label>Mail</label>
                    <input type="mail" />
                </div>

                <div className="form-group">
                    <label>Şifre</label>
                    <input type="password" placeholder="Şifre (6+ Karakter)" />
                </div>


                <div className="checkbox-group">
                    <label>
                        <input type="checkbox" /> Afaziliyim
                    </label>
                    <label>
                        <input type="checkbox" /> Afazili Yakınıyım
                    </label>
                </div>
                <div className="checkbox-terms">
                    <label>
                        <input type="checkbox" /> Bir hesap oluşturmak, Hizmet Şartlarımızı, Gizlilik Politikamızı ve varsayılan Bildirim Ayarlarımızı kabul ettiğiniz anlamına gelir.
                    </label>
                </div>
                <button type="submit" className="create-account-button">Hesap Oluştur</button>
            </form>
        </section>
    );
};

export default RegisterAfaziliRightSide;
